export const DISTRIBUTION_LIST_PRINT_STYLES = `
  .overflow-x-auto {
    padding: 0 !important;
    overflow: visible !important;
  }
  #htm-print-header {
    padding-bottom: 1.5rem !important;
  }
  #htm-print-header table,
  #htm-print-body table {
    width: 88% !important;
    margin-left: auto !important;
    margin-right: auto !important;
  }
  #htm-print-header td,
  #htm-print-body td {
    padding: 0.5rem !important;
  }
  #htm-print-header td[rowspan],
  #htm-print-body td[rowspan] {
    width: 12rem !important;
  }
  #htm-print-header td[rowspan] > div,
  #htm-print-body td[rowspan] > div {
    padding: 0.25rem !important;
  }
  #htm-print-header table img,
  #htm-print-body table img {
    width: auto !important;
    max-width: 8rem !important;
    height: auto !important;
    max-height: 4rem !important;
  }
  #htm-print-header table .text-base,
  #htm-print-body table .text-base {
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
  }
  #htm-print-body > div {
    break-inside: auto !important;
    page-break-inside: auto !important;
  }
  #htm-print-body .grid-cols-4 {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
  #htm-print-body .grid-cols-4 > div {
    border-right: none !important;
  }
  #htm-print-body .grid-cols-4 > div:nth-child(odd) {
    border-right: 1px solid var(--color-border-color) !important;
  }
  #htm-print-body .grid-cols-4 > div:nth-child(n + 3) {
    border-top: 1px solid var(--color-border-color) !important;
  }
  #htm-print-body .truncate {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    overflow-wrap: anywhere;
  }
  #htm-print-body .overflow-hidden {
    overflow: visible !important;
  }
  #htm-print-body .py-6 {
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
  }
  #htm-print-body .pb-6 {
    padding-bottom: 0.5rem !important;
  }
  #htm-print-body .mb-6 {
    margin-bottom: 0.5rem !important;
  }
  #htm-print-body .px-3 {
    padding-left: 0.375rem !important;
    padding-right: 0.375rem !important;
  }
  #htm-print-body .gap-4 {
    gap: 0.375rem !important;
  }
  #htm-print-body .h-12 {
    height: auto !important;
    min-height: 2rem !important;
  }
  #htm-print-body .w-14 {
    width: 2.5rem !important;
  }
  #htm-print-body .text-sm {
    font-size: 0.75rem !important;
    line-height: 1rem !important;
  }
  #htm-print-body .text-\\[15px\\] {
    font-size: 0.8125rem !important;
    line-height: 1.125rem !important;
  }
`;
